"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1({ price }, enganche) {
    return (enganche * price) / 100;
}
exports.default = default_1;
